import { render, staticRenderFns } from "./noNav.vue?vue&type=template&id=c15fa80c&scoped=true&"
import script from "./noNav.vue?vue&type=script&lang=js&"
export * from "./noNav.vue?vue&type=script&lang=js&"
import style0 from "./noNav.vue?vue&type=style&index=0&id=c15fa80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15fa80c",
  null
  
)

export default component.exports